import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      padding: ${theme.spacing.base} ${theme.spacing.base} 0 ${theme.spacing.base};
    `;
  }};
`;
